import { render } from "./Patients-List.vue?vue&type=template&id=1c9bbfdd&ts=true"
import script from "./Patients-List.vue?vue&type=script&lang=ts"
export * from "./Patients-List.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/dev.poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__